export default {
  account: 'Account',
  accountPlaceholder: 'Please enter account',
  operationTime: 'Operation Time',
  startTime: 'Start Time',
  endTime: 'End Time',
  search: 'Search',
  name: 'Name',
  ip: 'IP',
  applicationModule: 'Application Module',
  operationContent: 'Operation Content',
  antiFake: 'Anti-Counterfeiting',
  marketing: 'Marketing',
};
